import { render, staticRenderFns } from "./DownloadProgress.vue?vue&type=template&id=f6a4a70a&scoped=true&"
import script from "./DownloadProgress.vue?vue&type=script&lang=ts&"
export * from "./DownloadProgress.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadProgress.vue?vue&type=style&index=0&id=f6a4a70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a4a70a",
  null
  
)

export default component.exports